export function formatRegion(city?: string, state?: string, zip?: string) {
  return `${city || ''}${city && (state || zip) ? `, ${state || ''} ${zip || ''}` : `${state || ''} ${zip || ''}`}`?.trim();
}
